<template>
	<el-tabs id="userinfoList" value="first" type="border-card">
		<el-tab-pane name="first" :label="$t('labourInfo')">
			<el-row>
				<el-col :xs="24">
          <el-form :model="labourForm" :rules="rules" ref="labourForm" label-width="200px">
					  <el-card >
              <el-row>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('subtaskName1')" prop="subtaskId">
                    <el-select v-model="labourForm.subtaskId" disabled >
                      <el-option v-for="item in SubtaskList" :key="item.subtaskNumber" :label="item.subtaskName" :value="item.subtaskNumber"></el-option>
                    </el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('workDate1')" prop="workDate">
										<el-date-picker v-model="labourForm.workDate" disabled type="date" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('workContent1')" prop="workContent">
                    <el-input v-model="labourForm.workContent" disabled/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('workDescribe1')" prop="workDescribe">
                    <el-input v-model="labourForm.workDescribe" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('workHours1')" prop="workHours">
                    <el-input v-model="labourForm.workHours" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('travelHours1')" prop="travelHours" >
                    <el-input v-model="labourForm.travelHours" clearable :disabled="showLeave==1" :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
              </el-row>
              <!-- <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('hardwareProductLine1')" prop="hardwareProductLine">
                    <el-select v-model="labourForm.hardwareProductLine" clearable :disabled="showLeave==1">
											<el-option v-for="item in HardwareProductLineList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceProductLine1')" prop="serviceProductLine">
                    <el-select v-model="labourForm.serviceProductLine" clearable :disabled="showLeave==1">
											<el-option v-for="item in ServiceProductLineList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row> -->
              <el-row>
                <el-col :xs="24" :md="12" v-if="caseFlag">
									<el-form-item :label="caseName" prop="ocmsCaseNumber">
                    <el-input v-model="labourForm.ocmsCaseNumber" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12" v-if="accountFlag">
									<el-form-item :label="$t('accountName1')" >
                    <el-input v-model="labourForm.accountName" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('remark1')" >
                    <el-input v-model="labourForm.remark" clearable/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12" v-if="(labourForm.projectType=='MSS' ||labourForm.projectType=='WDC'||labourForm.projectType=='BC' ||labourForm.projectType=='PID'||labourForm.projectType=='PI')?true:false">
									<el-form-item :label="$t('ProductLine')"  prop="productLine">
                    <el-select v-model="labourForm.productLine" clearable>
                      <el-option v-for="item in ProductLineList" :key="item.pl2" :label="item.pl2" :value="item.pl2"></el-option>
                    </el-select>
									</el-form-item>
								</el-col>
							</el-row>

              <el-row>
                <el-col style="margin-top: 10px; text-align: center;" :xs="24" :md="24">
                  <el-button type="primary" @click="submitForm('labourForm')">{{$t('save')}}</el-button>
                  <el-button type="primary" size="medium" @click="returnList">{{$t('return')}}</el-button>
                </el-col>
              </el-row>
            </el-card>
          </el-form>
				</el-col>
			</el-row>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
    import {_debounce} from '@/utils/selectAPI'
    import * as validate from '@/utils/validate'
    export default {
        created () {
          this.getSubtaskList();
          this.getLabourHourData();
          this.getUserHourList();
          this.getProductLineList('');
        },
        data () {
          var checkHours = (rule, value, callback) => {
            let reg = /^\d+(\.\d{0,2})?$/;
            if(!reg.test(value)){
              return callback(new Error('Please enter integer or decimal to two places'));
            }
            if(this.showLeave == 1){
              if(value < 0.01 || value > 8){
                return callback(new Error('Please enter 0.01--8.00'));
              }
            }else{
              if(value < 0.01 || value > 24){
                return callback(new Error('Please enter 0.01--24.00'));
              }
            }
            let whour = this.labourForm.workHours;
            let thour = this.labourForm.travelHours;
            if(whour != null && thour != null){
              let sum = parseFloat(whour) + parseFloat(thour);
              if(sum > 24){
                return callback(new Error('The sum of WorkHours and TravelHours cannot exceed 24'));
              }
            }
            let wDate = this.labourForm.workDate;
            wDate = this.timeFormat(wDate);
            if(wDate != null && wDate != ""){
              let uhour = 0;
              this.userHours.forEach(item => {
                let iDate = this.timeFormat(item.workDate);
                if (iDate == wDate) {
                  uhour = item.workHours;
                }
              });
              let sum = parseFloat(whour) + parseFloat(uhour) - parseFloat(this.currhour);
              if(sum > 24){
                return callback(new Error('Working hours per day shall not exceed 24 hours'));
              }
            }
            callback();
          };
          var checkTravelHours = (rule, value, callback) => {
            let reg = /^\d+(\.\d{0,2})?$/;
            if(!reg.test(value)){
              return callback(new Error('Please enter integer or decimal to two places'));
            }else if(value < 0 || value > 24){
              return callback(new Error('Please enter 0--24.00'));
            }
            let whour = this.labourForm.workHours;
            let thour = this.labourForm.travelHours;
            if(whour != null && thour != null){
              let sum = parseFloat(whour) + parseFloat(thour);
              if(sum > 24){
                return callback(new Error('The sum of WorkHours and TravelHours cannot exceed 24'));
              }
            }
            callback();
          };
          var checkDescribe = (rule, value, callback) => {
            let content = this.labourForm.workContent;
            if(content == 'Others'){
              if(value == null || value == ''){
                return callback(new Error('Please enter describe'));
              }
            }
            callback();
          };
          var changeOcmsCaseNo = (rule, value, callback) => {
            if(this.showRequired){
              if(value == null || value == ""){
                return callback(new Error("Please input value"));
              }
            }
            callback();
          };
          return {
            rangeNumber: 10,
            labourForm: {
              projectId:null,
              taskId:null,
              subtaskId:null,
              workDate:null,
              workHours:null,
              workContent:null,
              workDescribe:null,
              travelHours:null,
              hardwareProductLine:null,
              serviceProductLine:null,
              ocmsCaseNumber:null,
              accountName:null,
              productLine:null,
            },
            showLeave:0,
            caseFlag:false,
            accountFlag:false,
            caseName:null,
            showRequired:false,
            SubtaskList:[],
            SubTList:[],
            currhour:0,
            userHours:[],
            ProductLineList:[],
            HardwareProductLineList:[
              { value: '1',label: '待定'},
            ],
            ServiceProductLineList:[
              { value: '1',label: '待定'},
            ],
            rules: {
              subtaskId: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              workDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              workHours: [
                { required: true, message:'Please input value', trigger: 'blur' },
                { validator: checkHours, trigger: 'blur' }
              ],
              workContent: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              workDescribe: [
                { validator: checkDescribe, trigger: 'blur' }
              ],
              travelHours: [
                { required: true, message:'Please input value', trigger: 'blur' },
                { validator: checkTravelHours, trigger: 'blur' }
              ],
              ocmsCaseNumber: [
                { validator: changeOcmsCaseNo, trigger: 'blur' }
              ],
              productLine: [
                { required: true, message:'Please select data', trigger: 'blur' },
              ],
            }
          }
        },
        methods: {
          getUserHourList(){
            let url =`${this.$store.state.islhurl}labourHour/getHour`;
            let pm = {
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res => {   
                this.userHours = res.labours;
              }
            )
          },
          getSubtaskList(){
            let url =`${this.$store.state.islhurl}subtask/getAllSubtaskToDetail`;
            let pm = {
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res => {   
                this.SubTList = res.data;
              }
            )
          },
          getProductLineList(subtaskRemark){
            let url = `${this.$store.state.islhurl}productline/getSelectData`
            let pm = {
              subtaskRemark:subtaskRemark,
              taskId: this.$route.params.taskId,
            }
            this._post(url,pm).then(
              res =>{
                this.ProductLineList = res.data;
              }
            )
          },
          //回显数据
          getLabourHourData(){
            let url = `${this.$store.state.islhurl}labourHour/getInfo`
            let pm = {
              id: this.$route.params.id,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res =>{
                //先加载下拉选项
                setTimeout(() => {
                  this.filterSubtaskCode(res.labourHour.subtaskId);
                }, 500);
                //再进行赋值
                this.labourForm = res.labourHour;
                this.currhour = res.labourHour.workHours;
                let labour = res.labourHour;
                this.getProductLineList(labour.projectType)
                if(labour.projectName == "GWL"){
                  this.showLeave = 1;
                }else{
                  this.showLeave = 0;
                }
                if(labour.projectName == "MSN"){
                  this.caseFlag = true;
                  this.showRequired = false;
                  this.caseName = 'IPMS Project Number：';
                }else if(labour.projectName == "MSP"){
                  this.caseFlag = true;
                  this.showRequired = false;
                  this.caseName = 'PMS Project Number：';
                }else if(labour.taskName == "Maintenance"){
                  this.caseFlag = true;
                  this.showRequired = true;
                  this.caseName = 'OCMS Case Number：';
                }else if(labour.projectName == "CDMA"){
                  this.caseFlag = true;
                  this.showRequired = false;
                  this.caseName = 'Service Contract Number：';
                }else if(labour.taskName == "Case"){
                  this.caseFlag = true;
                  this.accountFlag = true;
                  this.showRequired = true;
                  this.caseName = 'OCMS Case Number：';
                }else if(labour.taskName == "NECCase"){
                  this.caseFlag = true;
                  this.showRequired = true;
                  this.caseName = 'NEC Case Number：';
                }else if(labour.projectName == "CDROD"){
                  this.caseFlag = true;
                  this.showRequired = false;
                  this.caseName = 'OCMS Case Number：';
                }else{
                  this.caseFlag = false;
                  this.accountFlag = false;
                  this.showRequired = false;
                }
              }
            )
          },
          submitForm(formName) {
            this.$refs[formName].validate((pvalid) => {
              if (pvalid) {
                console.log('success submit')
                this.editInfo();
              } else {
                console.log('error submit!!');
                return false;
              } 
            });
          },
          editInfo(){
            let params = {
              labourId:this.$route.params.id,
              labourHour:this.labourForm,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            // console.log(params);
            let url = `${this.$store.state.islhurl}labourHour/editInfo`
            this._post(url,params).then(
              res => {
                if(res=="200"){
                  let pm = this.$route.params;
                  if(pm.returnF == 'Y'){
                    this.$router.push({path:'/labourEngineer/list'})
                  }else{
                    this.$router.push({path:'/labour/list'})
                  }
                  this.$Message.success('Save successful' )
                }else{
                  this.$message.error(res);
                }
              }
            )
          },
          returnList(){
            let pm = this.$route.params;
            if(pm.returnF == 'Y'){
              this.$router.push({name:'labourEngineer',params:pm});
            }else{
              this.$router.push({name:'labour',params:pm});
            }
          },
          filterSubtaskCode(filterVal){
            if(filterVal){
              let filterArr = this.SubTList.filter(item => {
                return item.subtaskNumber.toLowerCase().indexOf(filterVal.toLowerCase()) > -1;
              })
              this.SubtaskList = filterArr;
            }else{
              this.SubtaskList = this.SubTList;
            }
          },
          timeFormat (time) {
            if(time == null || time == ""){
              return null;
            }
            const dateTime = new Date(time);
            const year = dateTime.getFullYear();
            const month = dateTime.getMonth() + 1;
            const date = dateTime.getDate();
            // const hour = dateTime.getHours()
            // const minute = dateTime.getMinutes()
            // const second = dateTime.getSeconds()
            // return year + "-" +this.addZero(month) + "-" + this.addZero(date) + " " + this.addZero(hour) + ":" + this.addZero(minute) + ":" + this.addZero(second);
            return year + "-" + this.addZero(month) + "-" + this.addZero(date);
          },
          addZero (v) {
            return v < 10 ? '0' + v : v;
          }
        },
    }
</script>


// WEBPACK FOOTER //
// src/view/labour/labourEdit.vue